
import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import './SuperAdminDashboard.css';

const AdminCharts = ({ chartData }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (chartData && chartRef.current) {
            const chartInstance = echarts.init(chartRef.current);

            const option = {
                title: {
                    text: 'User Growth (Last 6 Months)',
                    left: 'center',
                    textStyle: {
                        color: '#333',
                        fontSize: 16
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: chartData.categories || [],
                    axisLine: { lineStyle: { color: '#ccc' } }
                },
                yAxis: {
                    type: 'value',
                    splitLine: { lineStyle: { type: 'dashed' } }
                },
                series: [
                    {
                        data: chartData.series || [],
                        type: 'line',
                        smooth: true,
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(58, 123, 213, 0.5)' },
                                { offset: 1, color: 'rgba(58, 123, 213, 0.1)' }
                            ])
                        },
                        itemStyle: {
                            color: '#3a7bd5'
                        }
                    }
                ]
            };

            chartInstance.setOption(option);

            const handleResize = () => {
                chartInstance.resize();
            };

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
                chartInstance.dispose();
            };
        }
    }, [chartData]);

    return (
        <div className="admin-chart-container">
            <div ref={chartRef} style={{ width: '100%', height: '300px' }}></div>
        </div>
    );
};

export default AdminCharts;
